import clsx from 'clsx';
import * as React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

export default function BlockGroup({ blok }) {
  const styles = clsx(`blok-blockgroup bg-[${blok.background_color.color}] dark text-white py-28 px-4 lg:px-16`);

  return (
    <div
      {...storyblokEditable(blok)}
      className={styles}
      style={{
        backgroundColor: blok.background_color.color,
        textAlign: blok.blocks_align,
      }}
    >
      {blok.blocks.map((block) => (
        <StoryblokComponent blok={block} key={block._uid} />
      ))}
    </div>
  );
}
